export default function ChevronDownIcon() {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.29259 7.29303C5.48012 7.10556 5.73443 7.00024 5.99959 7.00024C6.26476 7.00024 6.51906 7.10556 6.70659 7.29303L9.99959 10.586L13.2926 7.29303C13.4812 7.11087 13.7338 7.01008 13.996 7.01236C14.2582 7.01463 14.509 7.1198 14.6944 7.30521C14.8798 7.49062 14.985 7.74143 14.9873 8.00363C14.9895 8.26583 14.8888 8.51843 14.7066 8.70703L10.7066 12.707C10.5191 12.8945 10.2648 12.9998 9.99959 12.9998C9.73443 12.9998 9.48012 12.8945 9.29259 12.707L5.29259 8.70703C5.10512 8.5195 4.99981 8.26519 4.99981 8.00003C4.99981 7.73487 5.10512 7.48056 5.29259 7.29303Z'
        fill='currentColor'
        fillOpacity='0.5'
      />
    </svg>
  )
}
